/* Dev Sagaz — comportamento do tema. Sem dependências externas (Prism é carregado à parte nos posts). */
(function () {
    'use strict';
    var root = document.documentElement;
    var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
    var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
    var i18nEl = $('#dvsz-i18n'), T = { copy: 'Copiar', copied: 'Copiado!', linkCopied: 'Link copiado!', ad: 'Publicidade', code: 'Código', section: 'Seção % de %' };
    try { var parsed = JSON.parse(i18nEl.textContent); for (var k in parsed) if (parsed[k]) T[k] = parsed[k]; } catch (e) {}

    /* ---------------- Tema claro/escuro (a escolha fica no localStorage) ---------------- */
    function isDark() { return root.dataset.theme ? root.dataset.theme === 'dark' : matchMedia('(prefers-color-scheme: dark)').matches; }
    var themeBtn = $('#theme-toggle');
    if (themeBtn) {
        var sync = function () { themeBtn.setAttribute('aria-pressed', String(isDark())); };
        themeBtn.addEventListener('click', function () {
            var next = isDark() ? 'light' : 'dark';
            root.dataset.theme = next;
            try { localStorage.setItem('dvsz-theme', next); } catch (e) {}
            sync();
        });
        sync();
    }

    /* ---------------- Menu mobile ---------------- */
    var burger = $('.burger'), menu = $('#menu');
    if (burger && menu) {
        burger.addEventListener('click', function () {
            var open = menu.classList.toggle('open');
            burger.setAttribute('aria-expanded', String(open));
        });
    }

    /* ---------------- Copiar link ---------------- */
    $$('.copy-link').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var label = btn.querySelector('span'), original = label.textContent;
            navigator.clipboard.writeText(btn.dataset.url || location.href).then(function () {
                label.textContent = T.linkCopied;
                setTimeout(function () { label.textContent = original; }, 1800);
            });
        });
    });

    /* ---------------- Remover posts repetidos (home) ---------------- */
    var seen = {};
    var fallback = $('.hero-slot > .hero-card ~ .hero-fallback');
    if (fallback) fallback.remove();   /* há post featured: a reserva sai do DOM */
    $$('.hero-card[data-post-id]').forEach(function (el) { seen[el.dataset.postId] = true; });
    $$('[data-limit]').forEach(function (box) {
        var limit = parseInt(box.dataset.limit, 10) || 4, shown = 0;
        $$('[data-post-id]', box).forEach(function (el) {
            var id = el.dataset.postId;
            if (seen[id] || shown >= limit) { el.hidden = true; return; }
            seen[id] = true; shown++;
        });
        var section = box.closest('.home-section');
        if (section && shown === 0) section.hidden = true;
    });
    $$('.home-section').forEach(function (section, i) {
        if (i % 2 === 1) return;
        var first = $('.card:not([hidden])', section);
        if (first) first.classList.add('is-lead');
    });

    /* ---------------- Categorias: as principais não se repetem em "Todas" ---------------- */
    var mainTags = {};
    $$('.tag-grid-lg [data-tag-slug]').forEach(function (el) { mainTags[el.dataset.tagSlug] = true; });
    $$('.tag-grid [data-tag-slug]').forEach(function (el) { if (mainTags[el.dataset.tagSlug]) el.remove(); });

    /* ---------------- Artigo ---------------- */
    var content = $('.post-template .gh-content') || $('.page-template .gh-content');
    if (content) {
        /* Blocos de código: rótulo da linguagem + botão copiar */
        var LANG = { java: 'Java', kotlin: 'Kotlin', javascript: 'JavaScript', js: 'JavaScript', typescript: 'TypeScript', ts: 'TypeScript', python: 'Python', py: 'Python', sql: 'SQL', yaml: 'YAML', yml: 'YAML', bash: 'Bash', shell: 'Shell', sh: 'Shell', docker: 'Dockerfile', dockerfile: 'Dockerfile', cobol: 'COBOL', json: 'JSON', html: 'HTML', markup: 'HTML', css: 'CSS', go: 'Go', csharp: 'C#', php: 'PHP', jsx: 'JSX', tsx: 'TSX', groovy: 'Groovy', nginx: 'Nginx', ini: 'INI', properties: 'Properties', jcl: 'JCL' };
        $$('pre', content).forEach(function (pre) {
            if (pre.closest('.code-block')) return;
            var code = pre.querySelector('code');
            var m = code && code.className.match(/language-([\w-]+)/);
            var lang = m ? m[1].toLowerCase() : '';
            var wrap = document.createElement('div');
            wrap.className = 'code-block';
            var head = document.createElement('div');
            head.className = 'code-head';
            head.innerHTML = '<span class="code-lang"></span><button class="code-copy" type="button"></button>';
            head.lastChild.textContent = T.copy;
            head.firstChild.textContent = LANG[lang] || (lang ? lang.toUpperCase() : T.code);
            pre.parentNode.insertBefore(wrap, pre);
            wrap.appendChild(head);
            wrap.appendChild(pre);
            head.lastChild.addEventListener('click', function () {
                var b = this;
                navigator.clipboard.writeText((code || pre).innerText).then(function () {
                    b.textContent = T.copied; b.classList.add('done');
                    setTimeout(function () { b.textContent = T.copy; b.classList.remove('done'); }, 1800);
                });
            });
        });

        /* Tabelas: contêiner com rolagem lateral e borda arredondada */
        $$('table', content).forEach(function (tb) {
            if (tb.parentElement.classList.contains('table-wrap')) return;
            var w = document.createElement('div');
            w.className = 'table-wrap';
            tb.parentNode.insertBefore(w, tb);
            w.appendChild(tb);
        });

        /* Realce de sintaxe: carrega o Prism só se houver código com linguagem */
        if (i18nEl && i18nEl.dataset.prism && $('pre code[class*="language-"]', content)) {
            window.Prism = window.Prism || {};
            window.Prism.manual = true;   /* o realce é disparado aqui, quando o arquivo terminar de carregar */
            var ps = document.createElement('script');
            ps.src = i18nEl.dataset.prism;
            ps.async = true;
            ps.onload = function () { if (window.Prism && Prism.highlightAll) Prism.highlightAll(); };
            document.body.appendChild(ps);
        }

        /* Anúncio no meio do texto (depois do 6º parágrafo), se configurado */
        if (content.dataset.adClient && content.dataset.adSlot) {
            var paras = $$(':scope > p', content);
            if (paras.length > 8) {
                var ad = document.createElement('aside');
                ad.className = 'ad ad-inline';
                ad.setAttribute('aria-label', T.ad);
                ad.innerHTML = '<span class="ad-label"></span><div class="ad-box"><ins class="adsbygoogle" style="display:block; text-align:center;" data-ad-layout="in-article" data-ad-format="fluid"></ins></div>';
                ad.querySelector('.ad-label').textContent = T.ad;
                var ins = ad.querySelector('ins');
                ins.setAttribute('data-ad-client', content.dataset.adClient);
                ins.setAttribute('data-ad-slot', content.dataset.adSlot);
                paras[5].insertAdjacentElement('afterend', ad);
            }
        }

        /* Sumário a partir dos h2/h3 */
        var heads = $$(':scope > h2, :scope > h3', content);
        if (heads.length >= 3 && $('.post-template')) {
            heads.forEach(function (h, i) { if (!h.id) h.id = 'secao-' + (i + 1); });
            $$('.toc').forEach(function (toc) {
                var ol = document.createElement('ol');
                heads.forEach(function (h) {
                    var li = document.createElement('li'); li.className = 'lvl-' + h.tagName.charAt(1);
                    var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent;
                    a.addEventListener('click', function () { var d = toc.closest('details'); if (d) d.open = false; });
                    li.appendChild(a); ol.appendChild(li);
                });
                toc.appendChild(ol);
                var box = toc.closest('.toc-side, .toc-mobile');
                if (box) box.hidden = false;
            });
            var links = $$('.toc a'), progressTxt = $('.toc-progress');
            var h2s = heads.filter(function (h) { return h.tagName === 'H2'; });
            var setActive = function (id) {
                links.forEach(function (a) {
                    var on = a.getAttribute('href') === '#' + id;
                    a.classList.toggle('active', on);
                    if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
                });
                var idx = heads.findIndex(function (h) { return h.id === id; });
                var cur = h2s.filter(function (h) { return heads.indexOf(h) <= idx; }).length;
                if (progressTxt && h2s.length) { var n = 0; progressTxt.textContent = T.section.replace(/%/g, function () { return n++ === 0 ? Math.max(cur, 1) : h2s.length; }); }
            };
            if ('IntersectionObserver' in window) {
                var io = new IntersectionObserver(function () {
                    var current = heads.filter(function (h) { return h.getBoundingClientRect().top < window.innerHeight * 0.35; }).pop();
                    setActive((current || heads[0]).id);
                }, { rootMargin: '0px 0px -60% 0px' });
                heads.forEach(function (h) { io.observe(h); });
            }
            setActive(heads[0].id);
        }

        /* Barra de progresso de leitura */
        var bar = $('.progress span');
        if (bar) {
            var onScroll = function () {
                var r = content.getBoundingClientRect(), total = r.height - window.innerHeight * 0.6;
                bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, -r.top / (total > 0 ? total : 1))) + ')';
            };
            window.addEventListener('scroll', onScroll, { passive: true });
            onScroll();
        }

        /* Links externos do conteúdo abrem em nova aba */
        $$('a[href^="http"]', content).forEach(function (a) {
            if (a.hostname !== location.hostname) { a.target = '_blank'; a.rel = 'noopener'; }
        });
    }

    /* Ativa os blocos de anúncio presentes na página (o script do AdSense vem da injeção de código) */
    $$('ins.adsbygoogle').forEach(function () { try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) {} });

    /* ---------------- Notícias (RSS via rss2json) ---------------- */
    var newsBox = $('#news-list');
    if (newsBox) {
        var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
        var strip = function (h) { var d = document.createElement('div'); d.innerHTML = h || ''; return (d.textContent || '').replace(/\s+/g, ' ').trim(); };
        var fmt = new Intl.DateTimeFormat('pt-BR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
        var source = (function () { try { return new URL(newsBox.dataset.rss).hostname.replace(/^www\./, ''); } catch (e) { return ''; } })();
        /* 1º: proxy próprio no domínio (Cloudflare Worker /api/news); 2º: rss2json, se o proxy falhar */
        var rssParam = encodeURIComponent(newsBox.dataset.rss);
        var getJson = function (u) { return fetch(u).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).then(function (f) { if (!f.items || !f.items.length) throw new Error('vazio'); return f; }); };
        getJson('/api/news?rss=' + rssParam)
            .catch(function () { return getJson('https://api.rss2json.com/v1/api.json?rss_url=' + rssParam); })
            .then(function (feed) {
                var items = (feed.items || []).slice(0, 24);
                if (!items.length) throw new Error('vazio');
                newsBox.innerHTML = items.map(function (it) {
                    var d = new Date(String(it.pubDate).replace(' ', 'T'));
                    var intro = strip(it.description);
                    if (intro.length > 200) intro = intro.slice(0, 200).replace(/\s+\S*$/, '') + '…';
                    var cat = (it.categories && it.categories[0]) || 'Tecnologia';
                    var safeLink = /^https?:\/\//.test(it.link) ? it.link : '#';
                    return '<article class="news-item"><span class="card-tag">' + esc(cat) + '</span>' +
                        '<h2 class="news-title"><a href="' + esc(safeLink) + '" target="_blank" rel="noopener">' + esc(it.title) + '</a></h2>' +
                        '<p class="news-intro">' + esc(intro) + '</p>' +
                        '<p class="card-meta"><time datetime="' + (isNaN(d) ? '' : d.toISOString()) + '">' + (isNaN(d) ? '' : fmt.format(d)) + '</time>' +
                        (source ? '<span aria-hidden="true">·</span>' + esc(source) + ' ↗' : '') + '</p></article>';
                }).join('');
            })
            .catch(function () { newsBox.innerHTML = '<p class="news-error">' + esc(newsBox.dataset.error) + '</p>'; })
            .finally(function () { newsBox.setAttribute('aria-busy', 'false'); });
    }

    /* ---------------- "Carregar mais" (pagination.js do Source) ---------------- */
    if ($('.gh-feed') && $('.gh-loadmore') && typeof pagination === 'function') pagination(false);

    /* ---------------- Lightbox em galerias e imagens (lightbox.js do Source) ---------------- */
    if (typeof lightbox === 'function') {
        lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img');
    }
})();
